// extracted by mini-css-extract-plugin
export default {"card":"z5-z"};